const getImageBaseUrl = () => {
  const imageBase = process.env.REACT_APP_IMAGE_URL || "";
  const apiBase = process.env.REACT_APP_API_URL || "";
  return (imageBase || apiBase).replace(/\/api\/v1\/?$/i, "").replace(/\/+$/, "");
};

export const resolveAssetUrl = (path, fallback = "") => {
  if (path === null || path === undefined) return fallback;

  const raw = String(path).trim();
  if (!raw || raw === "null" || raw === "undefined") return fallback;
  if (/^(https?:)?\/\//i.test(raw) || raw.startsWith("data:") || raw.startsWith("blob:")) {
    return raw;
  }

  const clean = raw
    .replace(/\\/g, "/")
    .replace(/^\/+/, "")
    .replace(/^backend\/public\//i, "")
    .replace(/^public\//i, "")
    .replace(/^storage\/app\/public\//i, "storage/");

  const base = getImageBaseUrl();
  return base ? `${base}/${clean}` : `/${clean}`;
};
